// const ApiBaseUrl='http://127.0.0.1:8000/api';

const protocol = window.location.protocol
// const protocol = 'https:'

const ApiBaseUrl=`${protocol}//ctas.live/backend/api`;
const OcrImgBaseUrl=`${protocol}//ctas.live/ocr_backend/warehouse/`;

export {ApiBaseUrl,OcrImgBaseUrl};